import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      padding: '40px 24px',
    },
    content: {
      maxWidth: '800px',
      margin: '0 auto',
      background: 'white',
      borderRadius: '16px',
      padding: '48px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '32px',
    },
    logoImage: {
      height: '60px',
      width: 'auto',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '8px',
      textAlign: 'center',
    },
    subtitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#2C3E50',
      marginBottom: '32px',
      textAlign: 'center',
      fontStyle: 'italic',
    },
    paragraph: {
      fontSize: '1.1rem',
      color: '#4b5563',
      lineHeight: '1.8',
      marginBottom: '24px',
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#1f2937',
      marginTop: '32px',
      marginBottom: '16px',
    },
    buttonContainer: {
      textAlign: 'center',
      marginTop: '40px',
    },
    button: {
      display: 'inline-block',
      padding: '14px 32px',
      fontSize: '1rem',
      fontWeight: '600',
      color: 'white',
      background: '#1E40AF',
      border: 'none',
      borderRadius: '8px',
      textDecoration: 'none',
      cursor: 'pointer',
    },
    backLink: {
      display: 'block',
      textAlign: 'center',
      marginTop: '24px',
      color: '#6b7280',
      textDecoration: 'none',
      fontSize: '0.95rem',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.logo}>
          <img src="/Housecalclogo.png" alt="Estimate Assistant" style={styles.logoImage} />
        </div>

        <h1 style={styles.title}>About Estimate Assistant</h1>
        <p style={styles.subtitle}>Created by Construction People, for Construction People</p>

        <p style={styles.paragraph}>
          My family and I have been in various construction fields for decades. I've seen countless hours spent putting together estimates — measuring, pricing materials, calculating labor, and formatting everything into something professional enough to hand to a client.
        </p>

        <p style={styles.paragraph}>
          But here is the reality that you surely know as well as we do—sometimes all that work leads to nothing. The client wasn't serious. They were just "shopping around." Or they weren't ready to pull the trigger. Hours of your time, gone. That was time you could have spent with your family, running your business, or just taking a well-deserved break.
        </p>

        <h2 style={styles.sectionTitle}>That's why I built Estimate Assistant.</h2>

        <p style={styles.paragraph}>
          I wanted to create something that makes estimates fast and easy, but without the steep learning curve or expensive monthly fees that come with most contractor software. Something you can pick up and use right away, without watching hours of tutorials or calling tech support.
        </p>

        <h2 style={styles.sectionTitle}>This is just the beginning.</h2>

        <p style={styles.paragraph}>
          I'm actively building and improving this tool, and I want to hear from you. What's working? What's missing? What would make your job easier? Your feedback directly shapes what gets built next.
        </p>

        <div style={styles.buttonContainer}>
          <Link to="/contact" style={styles.button}>
            Contact Us
          </Link>
        </div>

        <Link to="/" style={styles.backLink}>
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}